import React from 'react';
import PropTypes from 'prop-types';

const TabPane = ({
  children, label, route, dataCy
}) => (
  <section data-label={label} data-route={route} data-cy={dataCy}>
    {children}
  </section>
);

const { oneOfType, string, element } = PropTypes;
TabPane.propTypes = {
  label: string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  icon: string,
  children: oneOfType([string, element]).isRequired,
  route: string,
  dataCy: string
};

TabPane.defaultProps = {
  icon: '',
  route: '',
  dataCy: ''
};

export default TabPane;
